export enum MdEnableStatusEnum {
	DISABLE,
	ENABLE,
}

export enum PartnerTypeEnum {
	CUSTOMER = 'PARTNER-TYPE.CUS',
	SUPPLIER = 'PARTNER-TYPE.SUP',
}


export enum FanchiseeStatusEnum {
	FRANCHISEE_STATUS_NORMAL = 'franchisee-status.init',//初始
	FRANCHISEE_STATUS_INITIATED = 'franchisee-status.initiated',// 已发起
	FRANCHISEE_STATUS_RECEIVED = 'franchisee-status.received',// 已查收
	FRANCHISEE_STATUS_COMPLETED = 'franchisee-status.completed',//已完成
}

export const FanchiseeStatus = {
	[FanchiseeStatusEnum.FRANCHISEE_STATUS_NORMAL]: '初始',
	[FanchiseeStatusEnum.FRANCHISEE_STATUS_INITIATED]: '已发起',
	[FanchiseeStatusEnum.FRANCHISEE_STATUS_RECEIVED]: '已查收',
	[FanchiseeStatusEnum.FRANCHISEE_STATUS_COMPLETED]: '已完成',
}


//消息提醒次数
export enum messageInformPeriodEnum {
	INFORMPERIOD_ONE = 'informPeriod.one',//一次
	INFORMPERIOD_MORE = 'informPeriod.more'//多次
}

//消息提醒类型
export enum messageInformModeEnum {
	INFORMMODE_SMS = 'informMode.sms',//短信
	INFORMMODE_OFFICIALACCOUNT = 'informMode.officialAccount',//公众号
	INFORMMODE_INSTATION = 'informMode.instation'//站内
}

//消息状态
export enum messageStatusEnum {
	MESSAGE_INIT = 'message.init',//未读
	MESSAGE_READ = 'message.read',//已读
	MESSAGE_END = 'message.end'//完成
}